// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"125":"Mensagem","157":"MensagemCadastro","596":"404"}[chunkId] + "." + {"125":"bab8a956","157":"fae80291","596":"ce8b9751"}[chunkId] + ".css";
};